var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-4 rounded-lg d-flex flex-column",attrs:{"elevation":"6","height":"100%","width":"100%"}},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"width":"100%","type":"card"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }